module.exports = __webpack_public_path__ + "static/media/pixel.7156fe9c.png";